import { productApi } from '@features/products/api/productApi';
import { useQuery } from '@tanstack/react-query';

export function useProductById(productId: number) {
  const {
    data: product,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['product-by-id', productId],
    queryFn: async () => {
      const product = await productApi.getProductById(productId);
      return product;
    },
  });

  return { product, isLoading, error };
}
